<template>
    <div id="contents">
      <div class="inner">
        <h3 class="main-title">회사소개</h3>
        <ul class="tab-wrap">
          <li><a href="/intro" class="tab-btn active">회사 소개</a></li>
          <li><a href="/history" class="tab-btn">회사 연혁</a></li>
        </ul>
      </div>
      <section class="company-intro-wrap">
        <article class="company_intro01">
          <div class="inner">
            <ul class="section-list section-list01">
              <li><span class="tx-blue">애</span>드매스만의 차별화 노하우로 완성된 바이럴마케팅은</li>
              <li><span class="tx-blue">드</span>라마틱한 광고효과와 함께 최고의 성공 동반자가 되어 드립니다</li>
              <li><span class="tx-blue">매</span>출성장을 확인할 수 있는 광고 지금 바로 함께 해보세요!</li>
              <li><span class="tx-blue">스</span>마트한 시작은 애드매스입니다</li>
            </ul>
            <img src="../resource/images/company_info_visual.png" class="img" alt="">
          </div>
        </article>
        <article class="company_intro02">
          <div class="inner">
            <ul class="section-list section-list02">
              <li>애드매스는 각종 온라인, 매스컴 광고를 집행하며,<br /> 수년간의 경력을 보유한 마케터들이 다양한 분야에서의 경험으로 노하우를 쌓아가고 있습니다. <br>
                빠르고 확실한 피드백으로 <strong>클라이언트만이 원하는 맞춤 마케팅</strong>을 약속드릴 수 있습니다.<br/>
                합리적인 마케팅은 결과가 중요한 만큼 애드매스에서 최고의 광고 효과를 보여 드리겠습니다.</li>
              <li>
                또한 변해가는 마케팅 시장에 회사도 멈추지 않고<br class="mobile-show"/>  끊임없이 새로운 마케팅 전략방안을 제시할 줄 알아야 한다고 생각합니다.<br/>
                단순히 광고주의 광고 대행사가 아닌 <strong>같이 성장할 수 있는 동반자</strong>를 지향합니다.<br/>
                100프로의 재계약률과 0프로의 해지율을 달성하기 위해 신뢰를 바탕으로 최선을 다하겠습니다.
              </li>
              <li>
                애드매스만의 차별화 노하우로 완성 된 마케팅<br/>
                드라마틱한 광고효과와 함께 최고의 성공 동반자가 되어 드립니다.<br/>
                매출성장을 확인할수 있는 광고 지금 바로 함께 해보세요!<br/>
                스마트한 시작은 애드매스 입니다.
              </li>
            </ul>
          </div>
        </article>
        <article class="company_intro03 maps-wrap">
          <div class="inner small">
            <div class="maps">
              <div style="height: 590px;"><a href="https://map.kakao.com/?urlX=474183.0&amp;urlY=1105266.0&amp;itemId=1061849593&amp;q=%EC%95%A0%EB%93%9C%EB%A7%A4%EC%8A%A4&amp;srcid=1061849593&amp;map_type=TYPE_MAP&amp;from=roughmap" target="_blank"><img class="map" src="http://t1.daumcdn.net/roughmap/imgmap/e73c1a16b852162300ac1fb2965eaaae1b6bc1964c9428364916f8cf5156af4d" width="1162px" height="588px"></a>
              </div>
            </div>
            <div class="maps-grid-box">
              <h4 class="gird-title">CONTACT INFO</h4>
              <ul class="maps-flex-box">
                <li>TEL<br>02-2067-1213</li>
                <li>Address<br>서울특별시 금천구 가산디지털1로 142 스카이밸리1차 5층 516호</li>
                <li>Hours<br>업무시간: 오전 9:30~ 오후 6:30</li>
              </ul>
            </div>
          </div>
        </article>

      </section>
    </div>
</template>
<script>


export default {
  name: 'page-notice',
  components: {

  },
  mounted() {
    if (document.body.clientWidth < 800) {
      this.curWidth = 1
    }
    document.body.classList.add('sub');
    this.scroll();
  },
  data () {
    return {
      curWidth: 2.5
    }
  },
  methods: {
    scroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || window.screenY;
      document.querySelectorAll("article").forEach(item => {
        if(scrollTop > item.offsetTop - window.innerHeight / this.curWidth){
          item.classList.add("on");
        }
      });
      window.requestAnimationFrame(this.scroll);
    }
  }

}

</script>